import React from 'react';

const NotFound = () => <h1>404- Page NotFound</h1>;

export default NotFound;
